import React from 'react';
import PlainText from '@components/plain-text';
import Tooltip from '@components/tooltip';
import { makePassportRatingUrl } from '../../utils/urlProvider';
import * as styles from './Firm.scss';
import { openPassportPopup } from '../../utils';
import CommentTooltipWithIcon from '../CommentTooltipWithIcon';
import FirmConfirmation from '../FirmConfirmation';
import { fixHangingPrepositions } from '../../utils/unhangPrepositions';
import strings from '../../strings';

const Firm = ({ row }) => {
  const { firm } = row;
  const {
    firmName,
    fullCityName,
    profile,
    firmTypeAbbreviation,
    comment,
  } = firm;

  const hasComment = !!comment;
  const text = `${fullCityName}, ${profile}`;
  const url = makePassportRatingUrl(firm.atiId);

  return (
    <div className={styles.firm}>
      <div className={styles.firstRow}>
        <div className={styles.info}>
          <div className={styles.firmName}>
            <Tooltip
              content={firmName}
              placement="top"
              trigger="mouseenter focus"
              maxWidth="fit-content"
            >
              <a
                className="glz-link glz-is-primary"
                href={url}
                target="_blank"
                onClick={e => openPassportPopup(e, url)}
                rel="noreferrer"
              >
                {firmName}
              </a>
            </Tooltip>
          </div>
          {hasComment &&
            <div className={styles.commentTooltip}>
              <CommentTooltipWithIcon comment={comment} />
            </div>
          }
        </div>
      </div>
      <div className={styles.secondRow}>
        <PlainText
          color="neutral-tone-4"
          className={styles.profileCity}
        >
          {text}
          {firmTypeAbbreviation && (
            <div className={styles.firmConfirmationContainer}>
              <Tooltip
                content={fixHangingPrepositions(strings.confirmedProfileTooltip)}
                placement="top"
                trigger="mouseenter focus"
                maxWidth={200}
              >
                <FirmConfirmation firmTypeAbbreviation={firmTypeAbbreviation} />
              </Tooltip>
            </div>
          )}
        </PlainText>
      </div>
    </div>
  );
};

export default Firm;
